import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_150: DocMigration = {
  maxSchemaVersion: "0.0.150",
  description: "Porches on upper floors should have manual control over whether to include railing",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];

      if (setting.type !== "PORCH_SETTINGS" && setting.type !== "REAR_PORCH_SETTINGS") {
        continue;
      }

      setting.upperFloorIncludeRailing = true;
    }

    return json;
  },
};

export default migration_0_0_150;
